export default "__VITE_ASSET__c10f6ce5__"